import { Controller } from "@hotwired/stimulus"

// Click-to-edit for one number. The value shows as text; clicking it swaps in a small form. Enter or the tick saves,
// Escape or the cross cancels, and leaving the field with a changed value saves it too. The server answers with a Turbo
// Stream that replaces the whole row, so this controller disappears with the old row and the new figure shows at once.
export default class extends Controller {
  static targets = ["display", "form", "input"]

  edit() {
    this.original = this.inputTarget.value
    this.displayTarget.classList.add("d-none")
    this.formTarget.classList.remove("d-none")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel() {
    this.inputTarget.value = this.original ?? this.inputTarget.value
    this.formTarget.classList.add("d-none")
    this.displayTarget.classList.remove("d-none")
    this.displayTarget.focus()
  }

  keydown(event) {
    if (event.key !== "Escape") return

    event.preventDefault()
    this.cancel()
  }

  // Safari and Firefox on macOS do not focus a button when it is clicked, so a click on the tick or the cross arrives as
  // a focusout with no related target. Remember the press so that focusout is not mistaken for leaving the field.
  hold() {
    this.holding = true
  }

  focusout(event) {
    if (this.holding) { this.holding = false; return }
    if (this.locked || this.formTarget.contains(event.relatedTarget)) return

    if (this.inputTarget.value !== this.original && this.formTarget.checkValidity()) {
      this.formTarget.requestSubmit()
    } else {
      this.cancel()
    }
  }

  // Once saving starts, stop further edits and a second submit.
  lock() {
    this.locked = true
    this.inputTarget.readOnly = true
  }
}
